import Hero from "../components/Hero";
import FeaturesSection from "../components/Features";
import AboutSection from "../components/About";
import WhyChooseSection from "../components/Whychoose";
import ProductsSection from "../components/Productsection";
import IndustriesSection from "../components/IndustriesSection";

const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <FeaturesSection />
      <ProductsSection />
      <IndustriesSection />
      <WhyChooseSection />
      
      
    </>
  );
};

export default Home;
